namespace TabAurous.Common {
    export interface GiftVoucherTransactionsRow {
        Id?: number;
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        CompanyId?: number;
        GvMasterId?: number;
        GvNumber?: string;
        Amount?: number;
        IssuedDate?: string;
        ExpiryDate?: string;
        IsSold?: boolean;
        IsRedeemed?: boolean;
        RedeemedVoucherTypeId?: number;
        RedeemedTransId?: number;
        RedeemedTransDate?: string;
        RedeemedValue?: number;
    }

    export namespace GiftVoucherTransactionsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'GvNumber';
        export const localTextPrefix = 'Common.GiftVoucherTransactions';
        export const deletePermission = 'Masters:GiftVoucher:Delete';
        export const insertPermission = 'Masters:GiftVoucher:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:GiftVoucher:Edit';

        export declare const enum Fields {
            Id = "Id",
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            CompanyId = "CompanyId",
            GvMasterId = "GvMasterId",
            GvNumber = "GvNumber",
            Amount = "Amount",
            IssuedDate = "IssuedDate",
            ExpiryDate = "ExpiryDate",
            IsSold = "IsSold",
            IsRedeemed = "IsRedeemed",
            RedeemedVoucherTypeId = "RedeemedVoucherTypeId",
            RedeemedTransId = "RedeemedTransId",
            RedeemedTransDate = "RedeemedTransDate",
            RedeemedValue = "RedeemedValue"
        }
    }
}
